import ceramicCoating1 from '../assets/img/boat/ceramic-coating1.jpg';
import gelcoat1 from '../assets/img/boat/gelcoat-correction.jpg';
import gelcoat2 from '../assets/img/boat/gelcoat-correction2.jpg';
import interior1 from '../assets/img/boat/interior-detailing1.jpg';
import interior2 from '../assets/img/boat/interior-detailing2.jpg';
import shrink from '../assets/img/boat/shrink-wrap1.jpg';
import shrink2 from '../assets/img/boat/shrink-wrap2.jpg';
import teak from '../assets/img/boat/teak-cleaning1.jpg';
import teak2 from '../assets/img/boat/teak-cleaning2.jpg';
import wewekly from '../assets/img/boat/weekly-wash.jpg';
import weekly2 from '../assets/img/boat/weekly-wash2.jpg';
import spot1 from '../assets/img/boat/windows-spot.jpg';
import spot2 from '../assets/img/boat/windows-spot2.jpg';


export const boatServices = [
    {
        id: "boat-ceramic-coating",
        name: "Ceramic coating",
        images: [ceramicCoating1]
    },
    {
        id: "gelcoat-correction",
        name: "Gelcoat correction",
        images: [gelcoat1, gelcoat2]
    },
    {
        id: "boat-interior-detailing",
        name: "Boat interior detailing",
        images: [interior1, interior2]
    },
    {
        id: "teak-clean",
        name: "Teak clean",
        images: [teak, teak2]
    },
    {
        id: "windows-water-spot-remover",
        name: "Windows water spot remover",
        images: [spot1, spot2]
    },
    {
        id: "boat-weekly-wash",
        name: "Weekly wash",
        images: [wewekly, weekly2]
    },
    {
        id: "shrink-wrap",
        name: "Shrink Wrap",
        images: [shrink, shrink2]
    },
];